import React from 'react';
import './SearchBox.css';

function SearchBox({ value, onChange }) {
  const handleClear = () => {
    onChange('');
  };

  return (
    <div className="search-box">
      <span className="search-icon">🔍</span>
      <input
        type="text"
        className="search-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search..."
      />
      {value && (
        <button 
          className="clear-search-btn"
          onClick={handleClear}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
}

export default React.memo(SearchBox);

